var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as storeAction from '../actions/settings.action';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { SettingsService } from '../../settings.service';
var SettingsEffect = /** @class */ (function () {
    function SettingsEffect(actions, storeService, store) {
        var _this = this;
        this.actions = actions;
        this.storeService = storeService;
        this.store = store;
        this.getStoreTimings = this.actions.ofType(storeAction.GET_STORE_TIMINGS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.storeService.getStoreTimings(body)
                .map(function (res) { return new storeAction.GetStoreTimingsSuccess(res); })
                .catch(function (error) { return of(new storeAction.GetStoreTimingsError(error)); });
        }));
        this.addTiming = this.actions.ofType(storeAction.ADD_NEW_TIMING)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.storeService.addNewTiming(body)
                .map(function (res) { return new storeAction.AddNewTimingSuccess(res); })
                .catch(function (error) { return of(new storeAction.AddNewTimingError(error)); });
        }));
        this.getStoreDetails = this.actions.ofType(storeAction.GET_STORE_DETAILS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.storeService.getStoreDetails(body)
                .map(function (res) { return new storeAction.GetStoreDetailsSuccess(res); })
                .catch(function (error) { return of(new storeAction.GetStoreDetailsError(error)); });
        }));
        this.updatepopupStoreTimings = this.actions.ofType(storeAction.UPDATE_STORE_TIMINGS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.storeService.updateStoreTimings(body)
                .map(function (res) { return new storeAction.UpdateStoreTimingsSuccess(res); })
                .catch(function (error) { return of(new storeAction.UpdateStoreTimingsError(error)); });
        }));
        this.updateStoreDetails = this.actions.ofType(storeAction.UPDATE_STORE_DETAILS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.storeService.updateStoreDetails(body)
                .map(function (res) { return new storeAction.UpdateStoreDetailsSuccess(res); })
                .catch(function (error) { return of(new storeAction.UpdateStoreDetailsError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SettingsEffect.prototype, "getStoreTimings", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SettingsEffect.prototype, "addTiming", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SettingsEffect.prototype, "getStoreDetails", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SettingsEffect.prototype, "updatepopupStoreTimings", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SettingsEffect.prototype, "updateStoreDetails", void 0);
    return SettingsEffect;
}());
export { SettingsEffect };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/settings/store/effects/settings.effect.ts.pre-build-optimizer.js